import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import React, { useState, useRef, useCallback } from 'react';
import { CREATE, Create, SaveButton, useNotify, useRefresh } from 'react-admin';
import { FormSpy } from 'react-final-form';

import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import SimpleFormWithSave from '../../../core/components/form/SimpleFormWithSave';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import dataProvider from '../../../core/providers/IccUserDataProvider';
import InvestorDetails from '../../investors/InvestorDetails';

const styles = () => ({
  fullWidth: {
    width: '100%'
  }
});

const OrganizationInvestorCreateDialog = props => {
  let investorFormProps = useRef({});
  const {
    handleDialogToggle,
    showDialog,
    classes,
    refreshView,
    ...createProps
  } = props;
  const [submitting, setSubmitting] = useState(false);
  const notify = useNotify();
  const notifyServerError = useNotifyServerError();
  const refresh = useRefresh();

  const setInvestorFormProps = useCallback(formProps => {
    investorFormProps.current = formProps;
  }, []);

  const handleSaveClick = useCallback(() => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    investorFormProps.current.form.submit();
  }, []);

  const handleClose = useCallback(() => {
    if (submitting) return;
    investorFormProps.current.form.reset();
    handleDialogToggle();
  }, [handleDialogToggle, submitting]);

  const handleSubmit = useCallback(
    values => {
      setSubmitting(true);

      dataProvider(CREATE, 'investors', {
        data: values
      })
        .then(() => {
          refresh();
          handleDialogToggle();
          notify('ra.notification.created');
        })
        .catch(notifyServerError)
        .finally(() => {
          investorFormProps.current.form.reset();
          setSubmitting(false);
        });
    },
    [handleDialogToggle, notify, refresh, notifyServerError]
  );

  return (
    <Dialog
      fullWidth
      open={showDialog}
      aria-label="Create new investor"
      maxWidth="md"
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return null;
        handleClose();
      }}
    >
      <DialogTitleWithCloseButton onClose={handleClose}>
        Create new investor
      </DialogTitleWithCloseButton>
      <DialogContent>
        {/* Override record object that contains investor information */}
        <Create {...createProps} record={{}} className={classes.fullWidth}>
          <SimpleFormWithSave
            toolbar={null}
            resource="investors" // We override the redux-form onSubmit prop to handle the submission ourselves
            onSave={handleSubmit}
            variant="standard"
            margin="normal"
            initialValues={{
              organizationId: props.id
            }}
          >
            <FormSpy>
              {props => {
                setInvestorFormProps(props);
                return <InvestorDetails creation disableTooltip />;
              }}
            </FormSpy>
          </SimpleFormWithSave>
        </Create>
      </DialogContent>
      <DialogActions>
        <SaveButton
          saving={submitting}
          handleSubmitWithRedirect={handleSaveClick}
          label="Create and Add"
          icon={<></>}
        />
        <Button
          onClick={handleClose}
          variant="outlined"
          color="primary"
          disabled={submitting}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(OrganizationInvestorCreateDialog);
